import React from "react";
import { updateNode } from "../../NodeUtils";


const FONT_WEIGHTS = [
  { label: "Light", value: 300 },
  { label: "Regular", value: 400 },
  { label: "Medium", value: 500 },
  { label: "Semi-Bold", value: 600 },
  { label: "Bold", value: 700 },
  { label: "Extra-Bold", value: 800 },
];

export function TypographyInspector({ page, setPage, result }) {
  const { sectionIndex, containerIndex, cardIndex, elementIndex } = result.path;
  const element = page.sections[sectionIndex]
    .contents[containerIndex]
    .cards[cardIndex]
    .elements[elementIndex];

 const style =
  element.styles?.custom?.typography ||
  (element.styles.custom = { typography: {} }).typography;
 const update = (changes) => {
  const updatedElement = {
    ...element,
    ...("content" in changes ? { content: changes.content } : {}),
    styles: {
      ...element.styles,
      custom: {
        ...element.styles.custom,
        typography: {
          ...style,
          ...changes,
        },
      },
    },
  };

  setPage(updateNode(page, element.id, updatedElement));
};

  return (
    <div>
      {/* TEXT CONTENT */}
      <label>Text</label>
      <textarea
        style={{ width: "100%", minHeight: 60 }}
        value={element.content || ""}
        onChange={(e) => update({ content: e.target.value })}
      />

      {/* FONT SIZE */}
      <label>Font Size</label>
      <input
        type="range"
        min="12"
        max="120"
        value={style.fontSize || 32}
        onChange={(e) => update({ fontSize: parseInt(e.target.value) })}
      />
      <div>{style.fontSize || 32}px</div>

      {/* FONT WEIGHT */}
      <label>Weight</label>
      <select
        value={style.fontWeight || 400}
        onChange={(e) => update({ fontWeight: parseInt(e.target.value) })}
        style={{ width: "100%" }}
      >
        {FONT_WEIGHTS.map(w => (
          <option key={w.value} value={w.value}>{w.label}</option>
        ))}
      </select>

      {/* TEXT ALIGN */}
      <label>Alignment</label>
      <div style={{ display: "flex", gap: 4 }}>
        {["left", "center", "right"].map(align => (
          <button key={align}
            style={{
              padding: 4,
              flex: 1,
              background: style.textAlign === align ? "#1A73E8" : "#eee",
              color: style.textAlign === align ? "#fff" : "#333"
            }}
            onClick={() => update({ textAlign: align })}
          >
            {align}
          </button>
        ))}
      </div>

      {/* TEXT TRANSFORM */}
      <label>Case</label>
      <select
        value={style.textTransform || "none"}
        onChange={(e) => update({ textTransform: e.target.value })}
        style={{ width: "100%" }}
      >
        <option value="none">Normal</option>
        <option value="uppercase">UPPERCASE</option>
        <option value="lowercase">lowercase</option>
        <option value="capitalize">Capitalize</option>
      </select>

      {/* LETTER SPACING */}
      <label>Letter Spacing</label>
      <input
        type="range"
        min="0"
        max="15"
        value={style.letterSpacing || 0}
        onChange={(e) => update({ letterSpacing: parseInt(e.target.value) })}
      />
      <div>{style.letterSpacing || 0}px</div>

      {/* LINE HEIGHT */}
      <label>Line Height</label>
      <input
        type="range"
        min="1"
        max="2"
        step="0.1"
        value={style.lineHeight || 1.2}
        onChange={(e) => update({ lineHeight: parseFloat(e.target.value) })}
      />
      <div>{style.lineHeight || 1.2}</div>

      {/* COLOR */}
      <label>Text Color</label>
      <input
        type="color"
        value={style.color || "#000000"}
        onChange={(e) => update({ color: e.target.value })}
        style={{ width: "100%" }}
      />

      <button
        style={{
          width: "100%",
          marginTop: 12,
          padding: "6px 0",
          background: "#eee",
          border: "1px solid #ccc",
          fontSize: 14,
        }}
        onClick={() => update({})}
      >
        Reset to default
      </button>
    </div>
  );
}
